import React from 'react'

import Currency from 'components/Currency'

import useLinearImpulse from 'hooks/useLinearImpulse'

interface Props {
  from: number
  to: number
  duration: number
}

const KoinCounter: React.SFC<Props> = ({ from, to, duration }) => {
  const value = Math.round(useLinearImpulse(from, to, duration))

  return <Currency value={value} />
}

export default KoinCounter
